var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-drawer',{attrs:{"title":"我是标题","visible":_vm.drawer,"direction":"rtl","before-close":_vm.handleClose},on:{"update:visible":function($event){_vm.drawer=$event}}},[_c('span',[_vm._v("我来啦!")])])
}
var staticRenderFns = []

export { render, staticRenderFns }